import { useMutation } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

/** Apunta un email a la waitlist de lanzamiento. Idempotente: si el email ya
 *  estaba (unique violation), lo tratamos como éxito silencioso. */
export function useJoinWaitlist() {
  return useMutation({
    mutationFn: async (email: string) => {
      const clean = email.trim().toLowerCase();
      const { error } = await supabase.from('waitlist').insert({ email: clean });
      if (error) {
        if (error.code === '23505') return; // ya estaba en la lista
        throw new Error(error.message ?? 'No pudimos guardar tu email');
      }
    },
  });
}
